export enum Features {
  // core flags
  IsBskyTeam = 'is_bsky_team',

  // debug flags
  DebugFeedContext = 'debug_feed_context',

  // feature flags
  ImportContactsOnboardingDisable = 'import_contacts:onboarding:disable',
  ImportContactsSettingsDisable = 'import_contacts:settings:disable',
  LiveNowBetaDisable = 'live_now_beta:disable',
  GroupChatsDisable = 'group_chats:disable',
  DmsNewMessageComposerEnable = 'dms:new_message_composer:enable',
  ComposerLanguageDetectionEnable = 'composer:language_detection:enable',
  PostGalleryEmbedEnable = 'post_gallery_embed:enable',
  NotificationsExpandedProfileCardEnable = 'notifications:expanded_profile_card:enable',
  AppviewFallbackMode = 'appview_fallback:mode',
  AppviewFallbackThresholds = 'appview_fallback:thresholds',
  SearchAppviewRoute = 'search_appview:route',
  StreamplaceWatchEnable = 'streamplace:watch:enable',
  PollsEnable = 'polls:enable',
  EventsEnable = 'events:enable',

  AATest = 'aa-test',
}
